<template>
  <div>
    <div
      v-show="!isForModal"
      class="mt-1"
    >
      <h5 class="text-black">
        <strong>Penerima</strong>
      </h5>
      <div>Penerima Broadcast</div>
    </div>
    <div
      :class="isForModal? '': 'border border-2 rounded-lg md:p-2 p-1 mt-2 border-[#E2E2E2]'"
      class=""
    >
      <div
        v-show="!isForModal"
        class="mb-1"
      >
        Silahkan pilih penerima
      </div>
      <div class="lg:w-[50%]">
        <BInputGroup class="input-group-merge ">
          <BInputGroupPrepend is-text>
            <b-img
              fluid
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/search-normal-1.svg"
              alt=""
            />
          </BInputGroupPrepend>
          <BFormInput
            :value="searchReceiver"
            size="md"
            placeholder="Cari Penerima"
            style="padding: 8px 2px"
            @input="$emit('update:searchReceiver', $event)"
          />
        </BInputGroup>
      </div>
      <div
        v-if="!groupContact.length"
        class="border border-2 rounded-lg md:p-2 mt-2 border-[#E2E2E2]"
      >
        <div class=" p-3 text-center">
          <b-img
            center
            class="opacity-25 w-[45px]"
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/add-circle.svg"
            alt=""
          />
          <div class="mt-1">
            <small class="text-center">
              Tidak ada data untuk ditampilkan
            </small>
          </div>

          <b-button
            size="sm"
            class="mt-1"
            variant="primary"
            @click="$router.push('/grup-contact')"
          ><div class="flex gap-3 items-center justify-center">
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/add.svg"
              alt=""
            >
            <div>Tambah Group Kontak</div>
          </div>
          </b-button>
        </div>
      </div>
      <div
        v-else
        id="scroll"
        ref="scroll"
        :class="isForModal? 'h-[30vh]': 'h-[50vh]'"
        class="border  overflow-y-auto border-2 p-2  rounded-lg mt-2 border-[#E2E2E2]"
        @scroll="handleScroll"
      >
        <BOverlay
          variant="light"
          :show="isLoading"
          spinner-variant="primary"
          blur="0"
          class=""
          opacity=".5"
          rounded="sm"
        >
          <div
            v-for="(group, index) in groupContact"
            :key="index"
            class="flex items-center gap-1"
          >
            <b-form-checkbox
              v-model="localGroupContactSelected"
              name="checkbox-1"
              :disabled="disabled"
              class="mt-[-1rem]"
              :value="group"
              @change="updateGroupContactSelected"
            />
            <label
              class=" mb-1 text-primary text-xs"
              for="gridCheck"
            >
              <div class="text-[12px] text-[400] text-[#333333]">{{ group.name }}</div>
              <small class="text-[10px] text-[400] text-primary">{{ group.total_contact }} kontak</small>
            </label>
          </div>
        </BOverlay>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BFormInput,
  BButton,
  BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BFormInput,
    BButton,
    BImg,
  },
  props: {
    groupContact: {
      type: [Array,
        String],
      default: () => [],
    },
    searchReceiver: {
      type: String,
      default: '',
    },
    groupContactSelected: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isForModal: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localGroupContactSelected: this.groupContactSelected.slice(),
    }
  },
  watch: {
    // Tambahkan watcher untuk groupContactSelected prop
    groupContactSelected: {
      handler(newValue) {
        // Update nilai lokal saat prop berubah
        this.localGroupContactSelected = newValue
      },
      immediate: true, // Pastikan dijalankan saat komponen dimuat
    },
  },
  methods: {
    updateGroupContactSelected(newValue) {
      this.localGroupContactSelected = newValue
      this.$emit('update:groupContactSelected', newValue)
    },
    handleScroll() {
      const { scrollTop, scrollHeight, clientHeight } = this.$refs.scroll
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.$emit('nextDataGroup')
      }
    },

  },
}
</script>
